const initialState = {
  pending: []
};

export default function notificationsReducer(state = initialState, action) {
  switch(action.type){
  case "ADD_NOTIFICATION":
    return { ...state, pending: [...state.pending, action.notification] };
  case "DISMISS_NOTIFICATION": {
    const notifications = state.pending.slice(1);

    return { ...state, pending: notifications };
  }
  default:
    return state;
  }
};



// WEBPACK FOOTER //
// ./app/reducers/settings/notifications.js